// extracted by mini-css-extract-plugin
export default {"student":"Table_student__RJVfB","root":"Table_root__sEo-E"};